import { debounce } from 'lodash'

export const debounceFilter = debounce((onFire: () => void) => {
  onFire()
}, 250)
